define('../app/fukit/view/block/fullscreen.calendar.view',['require','exports','module','underscore','uikit/uikit','../../helpers/extend.util','./segment.container.view'],function(require, exports, module) {
  //prettier-ignore
  var _                    = require('underscore'),
      UIKit                = require('uikit/uikit'),
      ExtendUtil           = require('../../helpers/extend.util'),
      SegmentContainerView = require('./segment.container.view');

  var FullscreenCalendarView = SegmentContainerView.extend({
    // attributes: { style: 'height: 50em;' },

    options: _.extend({}, SegmentContainerView.prototype.options, {
      fitted: true,
    }),

    components: function() {
      return [
        {
          type: UIKit.Calendar,
          name: 'calendar',
          size: 'large',
          appointmentList: true,
          innercelled: true,
          aligned: 'right',
          fluid: true,
          selectable: true,
          controls: false,
          collection: this.getOption('collection'),
        },
      ];
    },
  });

  module.exports = FullscreenCalendarView;
});

